module.exports = __webpack_public_path__ + "static/media/rasBg2.4711b393.png";